export default {
    title: "Rojeca ADR",
    telephoneNumber: "06 30397297",
    kvk: "60327448",
    street: "Schenkeldijk 45",
    city: "Strijen",
    zipcode: "3291 EN",
    email: "info@rojeca.nl",
    btw: "NL206139706B01",
}



// WEBPACK FOOTER //
// ./src/configurables/information.js